import { IApplicationState } from '../../../../../types/types';

export const getNewPerformanceAllowedValueSelector = (
    state: IApplicationState
) => state.cookieDialog.newPerformanceAllowedValue
